/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_ResultsInputs */

const id_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil`)
};

const ms_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil`)
};

const da_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultater`)
};

const de_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse`)
};

const en_us2_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const es_es2_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const es_mx2_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const fil_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Resulta`)
};

const fr_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats`)
};

const it_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

const hu_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eredmények`)
};

const nl_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultaten`)
};

const no_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultater`)
};

const pl_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki`)
};

const pt_br2_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const pt_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const ro_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezultate`)
};

const fi_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulokset`)
};

const sv_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultat`)
};

const vi_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết quả`)
};

const tr_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuçlar`)
};

const cs_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výsledky`)
};

const bg_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резултати`)
};

const ru_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты`)
};

const uk_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результати`)
};

const ar_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النتائج`)
};

const hi_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम`)
};

const th_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลลัพธ์`)
};

const ja_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果`)
};

const zh_cn2_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结果`)
};

const zh_hant1_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果`)
};

const ko_tags_results = /** @type {(inputs: Tags_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결과`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Tags_ResultsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_results = /** @type {((inputs?: Tags_ResultsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_ResultsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_results(inputs)
	if (locale === "ms") return ms_tags_results(inputs)
	if (locale === "da") return da_tags_results(inputs)
	if (locale === "de") return de_tags_results(inputs)
	if (locale === "en-US") return en_us2_tags_results(inputs)
	if (locale === "es-ES") return es_es2_tags_results(inputs)
	if (locale === "es-MX") return es_mx2_tags_results(inputs)
	if (locale === "fil") return fil_tags_results(inputs)
	if (locale === "fr") return fr_tags_results(inputs)
	if (locale === "it") return it_tags_results(inputs)
	if (locale === "hu") return hu_tags_results(inputs)
	if (locale === "nl") return nl_tags_results(inputs)
	if (locale === "no") return no_tags_results(inputs)
	if (locale === "pl") return pl_tags_results(inputs)
	if (locale === "pt-BR") return pt_br2_tags_results(inputs)
	if (locale === "pt") return pt_tags_results(inputs)
	if (locale === "ro") return ro_tags_results(inputs)
	if (locale === "fi") return fi_tags_results(inputs)
	if (locale === "sv") return sv_tags_results(inputs)
	if (locale === "vi") return vi_tags_results(inputs)
	if (locale === "tr") return tr_tags_results(inputs)
	if (locale === "cs") return cs_tags_results(inputs)
	if (locale === "bg") return bg_tags_results(inputs)
	if (locale === "ru") return ru_tags_results(inputs)
	if (locale === "uk") return uk_tags_results(inputs)
	if (locale === "ar") return ar_tags_results(inputs)
	if (locale === "hi") return hi_tags_results(inputs)
	if (locale === "th") return th_tags_results(inputs)
	if (locale === "ja") return ja_tags_results(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_results(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_results(inputs)
	return ko_tags_results(inputs)
});
export { tags_results as "tags.results" }